import * as React from 'react'
export const SvgTwitterOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M19.102 8.341c.01.158.01.316.01.476 0 4.863-3.701 10.471-10.47 10.471v-.003c-2 .003-3.959-.57-5.642-1.65a7.39 7.39 0 005.447-1.525 3.685 3.685 0 01-3.439-2.556c.552.107 1.12.085 1.662-.063a3.68 3.68 0 01-2.952-3.607v-.047a3.657 3.657 0 001.67.46A3.685 3.685 0 014.25 5.385a10.445 10.445 0 007.585 3.845 3.682 3.682 0 016.271-3.357 7.385 7.385 0 002.338-.893 3.694 3.694 0 01-1.618 2.035 7.32 7.32 0 002.113-.58 7.477 7.477 0 01-1.836 1.907z" />
  </svg>
)
export default SvgTwitterOutline
